export const rejectionReasons = [
  { id: 1, description: 'VALOR INVIÁVEL' },
  { id: 3, description: 'FALTA DE PAGAMENTO' },
  { id: 4, description: 'PERDA DE GARANTIA' },
  { id: 5, description: 'SEM RETORNO' },
  { id: 6, description: 'FORMA DE PAGAMENTO' },
  { id: 7, description: 'NF DE COMPRA OU DECLARAÇÃO' },
  { id: 8, description: 'REPARO PARCIAL' },
  { id: 9, description: 'GARANTIA ESTENDIDA' },
  { id: 10, description: 'GARANTIA ASSISTÊNCIA' },
  { id: 11, description: 'Número de telefone inválido' },
  { id: 12, description: 'E-mail inválido' },
  { id: 13, description: 'Sem retorno Whatsapp' },
  { id: 14, description: 'Outros' },
  { id: 15, description: 'Prazo de Pagamento' },
  { id: 16, description: 'CORTESIA' },
  { id: 17, description: '13º MES' },
  { id: 18, description: 'ACORDO SIS' },
  { id: 19, description: '+ DE 5 ANOS' },
  { id: 20, description: 'ACORDO CANCELADO' },
  { id: 21, description: 'IMPORTADO' },
  { id: 22, description: 'NÃO FOI PAGO A FRANQUIA' },
  { id: 23, description: 'REORÇAMENTO' },
  { id: 33, description: 'CONTATO SEM SUCESSO' },
  { id: 34, description: 'NAO ATENDE' },
  { id: 35, description: 'NÃO ACEITA' },
  { id: 36, description: 'DD' },
  { id: 37, description: 'TEMPO DE ATENDIMENTO' },
  { id: 38, description: 'SEM VALOR DE PEÇA' },
  { id: 39, description: 'CLIENTE JA COMPROU OUTRO PRODU' },
  { id: 40, description: 'LUCAS ENGENHARIA' },
  { id: 41, description: 'SEGURO' },
];
